import { render, staticRenderFns } from "./PhieuBaoHanh.vue?vue&type=template&id=0fca4df0&scoped=true&"
import script from "./PhieuBaoHanh.vue?vue&type=script&lang=js&"
export * from "./PhieuBaoHanh.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fca4df0",
  null
  
)

export default component.exports